<template>
  <div>
    <section
      :data-section="dataSection"
      class="e-section bg-img"
      :class="{
        phone: phoneOnly,
        'dark-gradient': !light,
        [background]: background,
      }"
      :data-theme="light ? 'light' : 'dark'"
    >
      <v-container>
        <v-img src="https://ik.imagekit.io/beingmuthu/FourSeasons/Reduced%20file%20size/e-footer%20bg.jpg?updatedAt=1691472786751" contain>
          <v-row class="fill-height" align="center" justify="center">
            <v-col md-4>
              <div class="section-title">
                <h1 class="headline">
                  <span>{{ headline }}</span>
                </h1>
                <div class="subtitle">
                  {{ subtitle }}
                </div>
                <hr class="white white--text" />
              </div>
            </v-col>            
          </v-row>
        </v-img>
      </v-container>
    </section>
  </div>
</template>

<script>
import GlobalComputed from "@/helpers/global-computed";
import GlobalMethods from "@/helpers/global-methods";
//import ContactForm from "@/components/custom/contact-form";

export default {
  //components: { ContactForm },
  props: {
    headline: {},
    subtitle: {},
    background: {},
    light: { type: Boolean, default: false },
    divider: { type: Boolean, default: false },
    dataSection: {},
  },
  data() {
    return {};
  },
  computed: {
    ...GlobalComputed,
  },
  methods: {
    ...GlobalMethods,
  },
};
</script>

<style lang="scss" scoped>
.e-section {
  color: white;
  background: url("https://ik.imagekit.io/beingmuthu/FourSeasons/Reduced%20file%20size/e-footer%20bg%20main.jpg?updatedAt=1691472787023") no-repeat center center fixed !important;
  background-size: cover;
  backdrop-filter: blur(2px);
  position: relative;
  // min-height: 600px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 3.25rem 0 !important;
  color: white;

  .section-title {
    text-align: center;
    .headline {
      margin-bottom: 0.5rem;
      color: rgba(#ffffff, 0.75);
    }
    .subtitle {
      font-size: 16px;
      color: rgba(#ffffff, 0.75);
    }
    hr {
      width: 75px;
      margin: 2rem auto 5rem auto;
      height: 1px;
      @media (max-width: 960px) {
        margin: 2rem auto 3rem auto;
      }
    }
  }

  &.phone {
    min-height: 350px;
    padding: 1.5rem 0 !important;

    .subtitle {
      font-size: 15px !important;
    }
  }
  .container {
    &:not(.container--fluid) {
      @media (min-width: 1264px) {
        max-width: 2585px;
      }
      @media (min-width: 1904px) {
        max-width: 2590px;
      }
      @media (max-width: 960px) {
        padding: 16px;
      }
    }
  }
}
</style>
